
import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';
import { Link } from 'react-router-dom';

const CTASection = () => {
  const [ref, inView] = useInView({ triggerOnce: true, threshold: 0.1 });

  const scrollToContact = () => {
    window.REACT_APP_NAVIGATE('/iletisim');
  };

  return (
    <section ref={ref} className="py-16 bg-gradient-to-br from-[#007dff] via-[#0066dd] to-[#007dff] relative overflow-hidden">
      <div className="relative z-10 max-w-[1440px] mx-auto px-8 text-center">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={inView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.6 }}
        >
          <p className="font-poppins font-semibold text-[12px] text-white uppercase tracking-wider mb-3">
            Hemen Başlayın
          </p>
          <h2 className="font-poppins font-bold text-3xl lg:text-4xl text-white mb-4 leading-tight">
            Acentenizi Dijitalde Büyütmeye Hazır mısınız?
          </h2>
          <p className="font-poppins text-base text-white max-w-2xl mx-auto mb-8 leading-relaxed">
            Ücretsiz dijital analiz ile acentenizin potansiyelini keşfedin. Size özel büyüme stratejinizi birlikte oluşturalım.
          </p>

          <div className="flex flex-wrap items-center justify-center gap-4">
            <button
              onClick={scrollToContact}
              className="px-7 py-3 bg-white text-[#007dff] text-[14px] font-semibold rounded-xl hover:shadow-2xl transition-all duration-300 whitespace-nowrap cursor-pointer hover:scale-105 active:scale-95 font-poppins"
            >
              Ücretsiz Analiz Al
            </button>
            <Link
              to="/paketler"
              className="px-7 py-3 bg-transparent text-white text-[14px] font-semibold rounded-xl border-2 border-white hover:bg-white hover:text-[#007dff] transition-all duration-300 whitespace-nowrap cursor-pointer hover:scale-105 active:scale-95 font-poppins"
            >
              Paketleri İncele
            </Link>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default CTASection;
